module.exports = "/images/jrmall-white.svg";